import React, { useEffect, useRef, useState } from 'react'
import ErrorMessage from 'components/common/ErrorMessage';
import toast from 'react-hot-toast';
import Api from "services/api"
import moment from 'moment';
import PhoneInput from 'components/common/PhoneInput';
import Swal from 'sweetalert2'
import ConfirmDataStep from './ConfirmDataStep';
import { Controller, FormProvider, useController, useForm, useFormContext } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { hospitalSelector } from 'slices/hospitalSlice';
import { setError } from 'slices/hospitalSlice';
import { Spinner } from 'reactstrap';
import { fetchCitys } from 'slices/citySlice';
import { fetchStates } from 'slices/stateSlice';
import { stateSelector } from 'slices/stateSlice';
import { citySelector } from 'slices/citySlice';
import { Select } from 'components/common/Select';
import { DialogTitle, Switch } from '@mui/material';
import { accountsSelector } from 'slices/accountSlice';
import { fetchTypes } from 'slices/typeSlice';
import { fetchLanguages } from 'slices/languageSlice';
import { updateAppointment } from 'slices/appointmentSlice';
import { addAppointment } from 'slices/appointmentSlice';
import { fetchAppointments } from 'slices/appointmentSlice';
import { AsyncPaginate } from 'react-select-async-paginate';
import { selectCustomStyles } from 'components/common/Select';
import { typesSelector } from 'slices/typeSlice';
import { setDynamicFields } from 'slices/accountSlice';
import { fetchMainClients } from 'slices/typeSlice';
import AfterAppointmentModal from './AfterAppointmentModal';
import { useNavigate } from 'react-router-dom';
import { BootstrapDialog } from 'components/subUsers/AddSubUsers';

const DEFAULT_APPOINTMENT_TYPE = "In Person";
const apiService = new Api();

export const timeToMinutes = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

const genderOptions = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'nonbinary', label: 'Nonbinary' },
]
const appointmentTypes = [
  {
    label: "In Person",
    value: "In Person"
  },
  {
    label: "Video Remote Interpretation",
    value: "Video Remote Interpretation"
  },
  {
    label: "OTP Pre Schedule",
    value: "OTP Pre Schedule"
  },
  {
    label: "OPI On Demand",
    value: "OPI On Demand"
  }

]

//#region ACCOUNTS SELCTION STEP
const AccountStep = ({ control, errors, dispatch, item, accounts, setConfirmData, mainAccount, setMainAccount, subClient, setSubclient, allSubAccounts, setAllSubAccounts, setValue }) => {

  const methods = useController({
    control,
    name: "account_id",
    rules: { required: true },
  });
  const { onChange } = methods.field;


  // #region Accounts dropdown
  const [allAccounts, setAllAccounts] = React.useState([]);

  useEffect(() => {
    if (item?.accounts) {
      setMainAccount({
        label: item?.accounts?.name || "",
        value: item?.accounts?.id || ""
      })
    }
  }, [item?.accounts])

  const filteredLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchTypes(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true))
    setAllAccounts(result?.data)
    return {
      options: result.data.map((item) => ({
        value: item.id,
        label: item.name,
      })),
      hasMore: page !== result?.last_page ? true : false,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion


  // #region Sub Accounts dropdown

  const [selectedSubAccount, setSelectedSubAccount] = useState({
    label: "",
    value: ""
  })
  const filteredSubAccount = React.useMemo(() =>
    allSubAccounts?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    }), [allSubAccounts]);


  const filteredAccounts = React.useMemo(() => {
    item?.accounts?.name && setAllSubAccounts(accounts?.find(account => account?.id == item?.accounts?.id)?.sub_accounts)

    return accounts?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    })
  }, [accounts, item?.accounts?.name]);

  useEffect(() => {
    setSelectedSubAccount(filteredSubAccount)
  }, [filteredSubAccount])

  useEffect(() => {
    if (item?.subclient?.name && item?.subclient?.id) {
      setSelectedSubAccount({
        label: item?.subclient?.name || "",
        value: item?.subclient?.id || ""
      })
    } else {
      setSelectedSubAccount(null)
    }
  }, [item?.subclient])

  //#endregion



  useEffect(() => {
    setConfirmData((prevData) => ({ ...prevData, subClientName: subClient?.label }))
    setConfirmData((prevData) => ({ ...prevData, subClientId: subClient?.value }))


  }, [subClient]);

  useEffect(() => {

    return () => {
      // setMainAccount({
      //   label: "",
      //   value: ""
      // })
    }
  }, [])


  return (
    <>
      <div className='step_cards step_1'>
        <h2>Select a Client</h2>

        <div className="row-primary">
          <h2>Client Account <span style={{ color: 'red' }}>*</span></h2>

          <Controller
            name="account_id"
            control={control}
            rules={{
              required: "Please select a Account"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={mainAccount}
                  defaultOptions={item?.accounts?.id ? filteredAccounts : []}
                  loadOptions={filteredLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setMainAccount(obj)
                    setAllSubAccounts(obj != null ? allAccounts?.find(account => account?.name == obj?.label)?.sub_accounts : [])
                    setConfirmData((prevData) => ({ ...prevData, clientName: obj?.label }))
                    setConfirmData((prevData) => ({ ...prevData, clientId: obj?.value }))
                    field.onChange(obj?.value);
                    setValue("sub_account_id", "")
                  }}
                  additional={{
                    page: item?.accounts?.id ? 2 : 1,
                  }}
                />
                {
                  errors?.account_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.account_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>Client Sub Account</h2>
          <Controller
            name="sub_account_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  onStateChanges={setSubclient}
                  name="sub_account_id"
                  options={filteredSubAccount || []}
                  {...field}
                  value={mainAccount ? (filteredSubAccount?.find((opt) => field.value === opt.value) || []) : null}
                />
                {errors?.city_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.city_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

      </div>
    </>
  )
}
//#endregion

//#region TYPE STEP
const TypeStep = ({ control }) => {
  // Switch work 
  const methods = useController({
    control,
    name: "type",
    rules: { required: true },
    // defaultValue: DEFAULT_APPOINTMENT_TYPE
  });

  const { setValue } = methods;

  // Switch work 

  return (
    <>
      <div className='step_cards step_2'>
        <h2>Appointment Type</h2>

        <div className='w-100 ps-3'>
          {/* <div className="row-primary">
            <h2 >Appointment Type <span style={{ color: 'red' }}>*</span></h2>
          </div> */}

          <Controller
            name="type"
            control={control}
            render={({ field }) => {
              return appointmentTypes?.map(type => (
                <div className="row-primary align-items-center flex-row">
                  <Switch checked={type.value === field.value} onChange={() => field.onChange(type.value)} />
                  <label htmlFor={type.value} onClick={() => field.onChange(type.value)} style={{ cursor: 'pointer' }} >
                    {type?.label}
                  </label>
                </div>
              ))
            }
            }
          />
        </div>
      </div>
    </>
  )
}
//#endregion

//#region DATE AND TIME
const DateTimeStep = () => {
  const { control, formState: { errors }, clearErrors, watch, setValue } = useFormContext();
  const startTime = watch("start_time");
  const estimatedDuration = watch("estimated_duration");

  // Function to calculate end time
  const calculateEndTime = (startTime, duration) => {
    if (!startTime || !duration) return "";
    const startMoment = moment(startTime, "HH:mm");
    return startMoment.add(duration, "minutes").format("HH:mm");
  };

  // Update end time when estimated duration changes
  useEffect(() => {
    if (startTime && estimatedDuration) {
      setValue("end_time", calculateEndTime(startTime, estimatedDuration));
    }
  }, [startTime, estimatedDuration, setValue]);
  useEffect(() => {
    setValue('date', moment().format('YYYY-MM-DD'))
    setValue('start_time', moment().format("HH:mm"))
    setValue('estimated_duration', 1)
  }, [])

  return (
    <div className='step_cards step_3'>
      <div className="row-primary">
        <h2>Date *</h2>
        <Controller
          name="date"
          control={control}
          rules={{ required: "Date is required" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <div className="input-image">
                <input type="date" {...field} value={field.value} onChange={(e) => field.onChange(moment(e.target.value).format('YYYY-MM-DD'))} />
                <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />
              </div>
              {errors?.date?.message && <ErrorMessage text={errors.date.message} />}
            </div>
          )}
        />
      </div>

      <div className="row-primary">
        <h2>Start Time*</h2>
        <Controller
          name="start_time"
          control={control}
          rules={{ required: "Please select start time" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <div className="input-image">
                <input type="time" {...field} />
                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
              </div>
              {errors?.start_time?.message && <ErrorMessage text={errors.start_time.message} />}
            </div>
          )}
        />
      </div>

      <div className="row-primary">
        <h2>Est Duration * (in minutes)</h2>
        <Controller
          name="estimated_duration"
          control={control}
          rules={{ required: "Please enter Estimated Duration", min: 1, max: 1440 }}
          render={({ field }) => (
            <input className="input-in type_inp" type="number" {...field} min={1} max={1440} onChange={(e) => setValue("estimated_duration", Math.max(1, e.target.value))} />
          )}
        />
        {errors?.estimated_duration?.message && <ErrorMessage text={errors.estimated_duration.message} />}
      </div>

      <div className="row-primary">
        <h2>End Time*</h2>
        <Controller
          name="end_time"
          control={control}
          rules={{ required: "Please select End time" }}
          render={({ field }) => (
            <div style={{ width: "100%" }}>
              <div className="input-image">
                <input type="time" {...field} />
                <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
              </div>
              {errors?.end_time?.message && <ErrorMessage text={errors.end_time.message} />}
            </div>
          )}
        />
      </div>
    </div>
  );
};

//#endregion

//#region LANGUAGE STEP
const LanguageStep = ({ control, errors, dispatch, item, setConfirmData, clientData, watch, languageState, setLanguageState, facilityState, setFacilityState, departmentState, setDepartmentState }) => {

  const { types: clients } = useSelector(typesSelector);
  useEffect(() => {
    if (clientData?.clientId) {
      dispatch(fetchTypes(1, { search: clientData.clientId }, true, false))
    }
  }, [clientData?.clientId])

  // #region Language dropdown
  useEffect(() => {
    if (item?.language) {
      setLanguageState({
        label: item?.language?.name || "",
        value: item?.language?.id || ""
      })
    } else {
      // setLanguageState([]);
    }
  }, [item?.language])

  const filteredLanguagesLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const result = await dispatch(fetchLanguages(page, { pageLength: 20, sortBy: "id", sortDirection: "asc", search: inputValue }, true, true));
    return {
      options: result.data.map(language => ({
        value: language.id,
        label: language.name,
      })),
      hasMore: page !== result?.last_page,
      additional: {
        page: page + 1,
      },
    };
  };
  //#endregion
  const selectedClient = React.useMemo(() => clients?.filter(i => i.id === clientData?.clientId)[0], [clientData, clients]);
  console.log("selectedClient", selectedClient, clients)
  // #region facility dropdown 
  const filteredFacilities = React.useMemo(() => {
    return selectedClient?.facilities?.map(item => ({
      label: item?.abbreviation,
      value: item?.id,
    })) || [];
  }, [selectedClient]);


  useEffect(() => {
    if (item?.facility) {
      setFacilityState({
        label: item?.facility?.abbreviation || "",
        value: item?.facility?.id || ""
      })
    } else {
      setFacilityState([]);
    }
  }, [item?.facility])
  //#endregion

  // #region Department dropdown
  const filteredDepartments = React.useMemo(() =>
    selectedClient?.departments?.map(item => {
      const object = {
        label: item?.name,
        value: item?.id,
      }
      return object
    }), [selectedClient]);

  useEffect(() => {
    if (item?.department) {
      setDepartmentState({
        label: item?.department?.name || "",
        value: item?.department?.id || ""
      })
    } else {
      setDepartmentState([]);
    }
  }, [item?.department])
  //#endregion

  const [selectedFacility, setSelectedFacility] = useState({});
  const [selectedDepartment, setSelectedDepartment] = useState({});

  useEffect(() => {
    setConfirmData((prevData) => ({ ...prevData, Facility: selectedFacility?.label }))
  }, [selectedFacility])
  useEffect(() => {
    setConfirmData((prevData) => ({ ...prevData, Department: selectedDepartment?.label }))
  }, [selectedDepartment])


  return (
    <>
      <div className='step_cards step_4'>
        <h2>Language / Facility / Department</h2>

        <div className="row-primary">
          <h2>Language <span style={{ color: 'red' }}>*</span></h2>
          <Controller
            name="language_id"
            control={control}
            rules={{
              required: "Please select a language"
            }}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <AsyncPaginate
                  menuPlacement='auto'
                  styles={{
                    ...selectCustomStyles,
                  }}
                  value={languageState}
                  loadOptions={filteredLanguagesLoadOptions}
                  isClearable
                  escapeClearsValue
                  onChange={(obj) => {
                    setLanguageState(obj)
                    setConfirmData((prevData) => ({ ...prevData, Language: obj?.label }))
                    field.onChange(obj?.value);
                  }}
                  additional={{
                    page: 1,
                  }}
                />
                {
                  errors?.language_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.language_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>

        <div className="row-primary">
          <h2>{`Facility`}</h2>

          <Controller
            name="facility_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <Select
                  onStateChanges={setSelectedFacility}
                  name="facility_id"
                  options={filteredFacilities || []}
                  {...field}
                  value={facilityState ? (filteredFacilities?.find((opt) => field.value === opt.value) || []) : null}
                />
              </div>
            }
          />
        </div>

        {watch("type") == "In Person" && (
          <div className="row-primary">
            <h2>{`Address ${!watch("facility_id") ? "*" : ""}`}</h2>

            <div style={{ width: "100%" }}>
              <Controller
                name="address"
                control={control}
                disabled={watch("facility_id")}
                render={({ field }) =>
                  <input
                    type="text"
                    name='address'
                    className="input-in type_inp"
                    placeholder=''
                    {...field}
                    disabled={watch("facility_id")}
                  />
                }
              />

              {errors?.address?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.address?.message} />
                </div>
              }
            </div>
          </div>
        )
        }

        <div className="row-primary">
          <h2>Department</h2>
          <Controller
            name="department_id"
            control={control}
            render={({ field }) =>
              <div style={{ width: "100%" }}>
                <div className="row-primary" >
                  <Select
                    onStateChanges={setSelectedDepartment}
                    name="department_id"
                    options={filteredDepartments || []}
                    {...field}
                    value={departmentState ? (filteredDepartments?.find((opt) => field.value === opt.value) || []) : null}
                  />
                  {(watch("type") == "In Person") &&
                    <Controller
                      name="department_text"
                      control={control}
                      render={({ field }) =>
                        <input
                          type="text"
                          name='department_text'
                          className="input-in type_inp"
                          placeholder=''
                          {...field}
                        />
                      }
                    />
                  }
                </div>
                {errors?.department_id?.message &&
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage text={errors?.department_id?.message} />
                  </div>
                }
              </div>
            }
          />
        </div>
      </div>
    </>
  )
}
//#endregion

//#region  FILTERS
const FilterStep = ({ control, fields, setFields }) => {

  const handleChangeRadios = (value, onChange, field) => {
    onChange(value == 1 ? 0 : 1);
  };

  return (
    <>
      <div className='step_cards step_4'>
        <h2>Filters</h2>
        <div className='w-100'>
          {fields.map((val) => (
            <div className={`row-primary align-items-center ${val.isLocked && 'lock_row'}`}>
              <h2 className="col-6 mt-0">{val.label}</h2>
              <Controller
                name={val.name}
                control={control}
                render={({ field }) => (
                  <div className="switch_row">
                    <Switch
                      className={val?.isLocked && "lockSwitch"}
                      checked={field.value === 1}
                      onChange={() => handleChangeRadios(field.value ? 1 : 0, field.onChange, field)}
                      color="primary"
                    />
                  </div>
                )}
              />
              {val?.isLocked ?
                <h2 className='mt-0 fst-italic'>locked</h2>
                : <></>
              }
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
//#endregion

//#region REQUESTER DATA
const UserDataStep = ({
  control,
  errors
}) => {

  return (
    <>
      <div className='step_cards step_5'>
        <h2>Required Data</h2>
        <div className='w-100'>
          <div className="row-primary">
            <h2>Requester Full Name <span style={{ color: 'red' }}>*</span></h2>
            <div className='w-100'>
              <Controller
                name="requester_name"
                rules={{
                  required: "Please enter Name",
                }}
                control={control}
                render={({ field }) => <input className="input-in type_inp" type="text" name='requester_name' placeholder='Requester Full Name' required {...field} />}
              />
              {
                errors?.requester_name?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_name?.message} />
                </div>
              }
            </div>
          </div>

          <div className="row-primary">
            <h2>Requester Email <span style={{ color: 'red' }}>*</span></h2>
            <div className="w-100">
              <Controller
                name="requester_email"
                rules={{
                  required: "Please enter email",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                    message: "Please enter a valid email address",
                  },
                }}
                control={control}
                render={({ field }) => <input className="input-in type_inp" type="email" name='requester_email' placeholder='Requester email' required {...field} />}
              />
              {
                errors?.requester_email?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.requester_email?.message} />
                </div>
              }
            </div>
          </div>

          <div className="row-primary">
            <h2>Caller Phone Number <span style={{ color: 'red' }}>*</span></h2>
            <div className="w-100">
              <Controller
                name="caller_phone"
                rules={{
                  required: "Please enter phone",
                }}
                control={control}
                render={({ field }) => <PhoneInput className="input-in type_inp" type="tel" name='caller_phone' placeholder='Caller Phone number' required {...field} />}
              />
              {
                errors?.caller_phone?.message &&
                <div style={{ marginBottom: 10 }}>
                  <ErrorMessage text={errors?.caller_phone?.message} />
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
//#endregion

// #region DYNAMIC FIELDS
const DynamicStep = ({ control, errors, watch, dynamicFields, values, setValues }) => {
  return (
    <div className='step_cards step_5'>
      {/* <h2>Required Data</h2> */}
      <div className='w-100'>
        {values?.length > 0 &&
          values?.map((f, index) => (
            f?.name && (
              <div key={index} className='w-100'>
                <div className="row-primary">
                  <h2>{f.name} {f?.required ? "*" : ""}</h2>
                  <Controller
                    name={`dynamic_fields.${index}.value`}
                    control={control}
                    defaultValue={f.value || ""}
                    rules={f?.required ? {
                      required: `Please enter ${f.name}`
                    } : {}}
                    render={({ field }) => (
                      <div className='w-100'>
                        <input
                          className="input-in type_inp"
                          type="text"
                          required={f?.required}
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            const updatedValues = [...values];
                            updatedValues[index] = {
                              ...updatedValues[index],
                              value: e.target.value,
                            };
                            setValues(updatedValues);
                          }}
                        />
                        {
                          errors?.dynamic_fields?.[index]?.value?.message &&
                          <div style={{ marginBottom: 10 }}>
                            <ErrorMessage text={errors?.dynamic_fields?.[index]?.value?.message} />
                          </div>
                        }
                      </div>
                    )}
                  />
                </div>
              </div>
            )
          ))}
      </div>
    </div>
  )
}
//#endregion

//#region GenderStep
const GenderNoteStep = ({
  control,
}) => {

  return (
    <>
      <div className='step_cards step_5'>
        {/* <h2>Required Data</h2> */}
        <div className='w-100'>

          <div className="row-primary">
            <h2>Interpreter Gender</h2>
            <Controller
              name="gender"
              control={control}
              render={({ field }) =>
                <div style={{ width: "100%" }}>
                  <Select
                    name="gender"
                    options={genderOptions || []}
                    {...field}
                    value={field.value ? genderOptions?.find((opt) => field.value == opt.value) : ""}
                  />
                </div>
              }
            />
          </div>


          <div className="row-primary">
            <h2>Notes</h2>
            <Controller
              name="notes"
              control={control}
              render={({ field }) => <textarea className="input-in type_inp" name='notes' placeholder='Enter some notes'  {...field} />}
            />
          </div>

        </div>
      </div>
    </>
  )
}
//#endregion


//#region APPOINTMENT FORM 
const AddAppointmentForm = ({ item, handleClose, callback, show }) => {
  //#region INITIALIZATION / STATES / VARIABLES
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [card5Values, setCard5Values] = useState([]);  //this is an array of values
  const method = useForm({
    defaultValues: {
      account_id: "",
      sub_account_id: "",
      date: moment().format('YYYY-MM-DD'),
      language_id: "",
      facility_id: "",
      department_id: "",
      gender: "",
      notes: "",
      caller_phone: "",
      requester_name: "",
      dynamic_fields: [],
      type: DEFAULT_APPOINTMENT_TYPE,
      auto_assign: 0
    }
  });
  const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, setError: setErrors } = method;
  const { error, loader } = useSelector(hospitalSelector);
  const { state: states } = useSelector(stateSelector);
  const { city: cities } = useSelector(citySelector);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { types: accounts } = useSelector(typesSelector);
  const { dynamicFields } = useSelector(typesSelector);
  const [ConfirmData, setConfirmData] = useState({
    clientName: '',
    clientId: '',
    subClientName: '',
    subClientId: '',
    Language: '',
    Facility: '',
    Department: '',

  });


  //#region States for accounts

  const [mainAccount, setMainAccount] = useState({
    label: "",
    value: ""
  });

  const [subClient, setSubclient] = useState({});
  const [allSubAccounts, setAllSubAccounts] = useState([]);

  const { types: mainClients } = useSelector(typesSelector);
  const { accounts: subClients } = useSelector(accountsSelector);
  // const dynamicFields = useMemo(() => !watch('sub_account_id') ? dynamicFieldsMainAccount : dynamicFieldsSubAccount, [watch('sub_account_id')]);
  //#endregion


  //#region LANGUAGE
  const [languageState, setLanguageState] = useState({
    label: "",
    value: ""
  });
  //#endregion

  //#region Facility

  const [facilityState, setFacilityState] = useState({
    label: "",
    value: ""
  })

  //#endregion

  //#region Department

  const [departmentState, setDepartmentState] = useState({
    label: "",
    value: ""
  })

  //#endregion


  //#region FILTERS
  const [fields, setFields] = useState(
    [
      { label: "US Based Interpreter", name: "us_based", isLocked: 0 },
      { label: "Non US Based Interpreter", name: "non_us_based", isLocked: 0 },
      { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
      { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
      { label: "Court Certified", name: "court_certified", isLocked: 0 },
      { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ]
  );


  //#endregion


  //#endregion


  //#region RESET DATA
  const resetAllFields = () => {

    dispatch(setError({}))
    setValue("type", DEFAULT_APPOINTMENT_TYPE);

    setValue("date", moment().format('YYYY-MM-DD'))

    setValue('requester_name', '');
    setValue('requester_email', '');
    setValue('caller_phone', '');
    setValue('gender', '');

    setValue('account_id', '');
    setValue('language_id', '');
    setValue('sub_account_id', '');
    setValue('name', '');
    setValue('status', 1)
    setValue("city_id", '')
    setValue("state_id", '')
    setValue("dynamic_fields", []);
    setValue("auto_assign", 0)
    setCurrentIndex(0);

    setMainAccount({
      label: "",
      value: ""
    })
    setLanguageState({
      label: "",
      value: ""
    })
    setFacilityState({
      label: "",
      value: ""
    })
    setDepartmentState({
      label: "",
      value: ""
    })
    setFields([
      { label: "US Based Interpreter", name: "us_based", isLocked: 0 },
      { label: "Non US Based Interpreter", name: "non_us_based", isLocked: 0 },
      { label: "English To Target Language", name: "english_to_target", isLocked: 0 },
      { label: "Spanish To Target Language", name: "spanish_to_target", isLocked: 0 },
      { label: "Court Certified", name: "court_certified", isLocked: 0 },
      { label: "Medical Certified", name: "medical_certified", isLocked: 0 },
    ])




    //#region Language facility reset fields

    setValue("department_id", '');
    setValue("department_text", '');
    setValue('language_id', '');
    setValue('facility_id', '');
    setValue('address', '');

    setValue('start_time', moment(new Date, ["h:mm A"]).format("HH:mm"));
    setValue('end_time', moment(new Date, ["h:mm A"]).add(15, "minutes").format("HH:mm"));
    setValue('estimated_duration', 0);

    //#endregion
  };
  //#endregion

  //#region USEEFFECTS

  const fetchSubClient = async () => {
    const result = await Api.fetchTypes(1, { search: watch("account_id") });
    if (result?.status == 200) {
      return await result?.data?.data?.data
    }
    else {
      console.log("Error fetching client")
      return null
    }
  }

  useEffect(() => {
    if (watch('account_id')) {
      const account_id = watch("account_id");
      account_id ? dispatch(fetchMainClients(account_id, true, true)) : dispatch(setDynamicFields([]))
      async function fetchClient() {
        const result = await fetchSubClient()
        if (result?.length > 0) {
          setAllSubAccounts(result[0]?.sub_accounts)
        }

      }
      fetchClient()

    }
  }, [watch("account_id")])



  useEffect(() => {
    setCurrentIndex(0)
    return () => {
      setCurrentIndex(0)
    }
  }, []);
  useEffect(() => {

    // dispatch(fetchTypes(1, { pageLength: 10, sortBy: "id", sortDirection: "asc" }));
    dispatch(fetchCitys(1, { pageLength: 10, sortBy: "id", sortDirection: "asc" }));
    dispatch(fetchStates(1, { pageLength: 10, sortBy: "id", sortDirection: "asc" }))

    return () => resetAllFields()
  }, [show])

  useEffect(() => {

    if (show && item?.id) {
      setValue('account_id', item?.account_id || '');
      setValue('sub_account_id', item?.subclient_id || '');
      setValue('name', item?.name || '');
      setValue('date', moment(item?.date).format('YYYY-MM-DD'))
      setValue('department_id', item?.department_id || '')
      setValue('language_id', item?.language_id || '');
      setValue('facility_id', item?.facility_id || '');
      setValue('department_id', item?.department_id || '');
      setValue('requester_name', item?.requester_name || '');
      setValue('caller_phone', item?.caller_phone || '');
      setValue('gender', item?.gender || '');
      if (item?.dynamic_fields && typeof (item?.dynamic_fields) == "string")
        setValue("dynamic_fields", JSON.parse(item?.dynamic_fields) || [])
      setValue('status', (typeof (item?.status) == "number") ? item?.status : 1)

      dispatch(setError({}))
    }
    return () => resetAllFields()

  }, [item, show])

  useEffect(() => {

    if (states?.length > 0) {
      if (item?.state_id)
        setValue("state_id", item?.state_id)
    }
    if (item?.city_id) setValue("city_id", item?.city_id)
  }, [item, cities, states]);

  useEffect(() => {
    if (!item?.dynamic_fields) {

      setCard5Values(
        dynamicFields?.length > 0 && dynamicFields?.map(f => ({ name: f?.name, value: "", required: f?.required == 1 ? true : false }))
      )
    } else {
      const dynamic_fields = item?.dynamic_fields ? JSON.parse(item?.dynamic_fields) : []
      setCard5Values(dynamic_fields?.map(f => ({ name: f?.name, value: f?.value, required: f?.required == 1 ? true : false })))
    }
  }, [dynamicFields, item?.dynamic_fields])

  useEffect(() => {
    if (card5Values?.length > 0) {
      setValue("dynamic_fields", card5Values)
    }
  }, [card5Values])

  useEffect(() => {
    if (accounts?.length > 0) {
      if (item?.account_id) {
        dispatch(fetchTypes(1, { search: item?.accounts?.name }, true, false))
        setValue("account_id", item?.account_id);
      }
    }

    if (item?.subclient_id) {
      setValue("sub_account_id", item?.subclient_id)
    }

  }, [item?.account_id, accounts]);


  useEffect(() => {
    setConfirmData({
      clientName: item?.accounts?.name || '',
      clientId: item?.accounts?.id || '',
      subClientName: item?.subclient?.name || '',
      subClientId: item?.subclient?.id || '',
      Language: item?.language?.name || '',
      Facility: item?.facility?.abbreviation || '',
      Department: item?.department?.name || '',
    })
  }, [item]);


  useEffect(() => {
    fields?.forEach(field => {
      setValue(field.name, 0)
    })

  }, [])

  useEffect(() => {
    // let clients = ConfirmData?.subClientId ? subClients : mainClients;

    // const client = clients.find(c => c.id == (watch("sub_account_id") || watch("account_id")));
    // const fetchSubClient = async () => {
    //   const result = await Api.fetchAccounts(1, { search: watch("sub_account_id") });
    //   if (result?.status == 200) {
    //     return await result?.data?.data?.data
    //   }
    //   else {
    //     console.log("Error fetching client")
    //     return null
    //   }
    // }
    const fetchClient = async () => {
      const result = await Api.fetchTypes(1, { search: watch("account_id") });
      if (result?.status == 200) {
        return await result?.data?.data?.data
      }
      else {
        console.log("Error fetching client")
        return null
      }
    }
    // async function filterSubWork() {
    //   if (watch("sub_account_id")) {
    //     const subclient = await fetchSubClient();
    //     if (subclient?.length > 0) {
    //       let client = subclient[0]



    //       if (client?.filters) {

    //         // return
    //         setFields(
    //           fields => fields?.map(field => {
    //             if (!field) {
    //               return { ...field, isLocked: false }
    //             }
    //             // console.log("client?.", client?.filters, [field.name])
    //             // return field
    //             if (client?.filters?.[field.name]) {
    //               const object = {
    //                 ...field,
    //                 isLocked: client?.filters?.[`${field.name}_locked`],
    //               }
    //               setValue(field.name, client?.filters?.[field.name])
    //               return object

    //             } else {
    //               return field
    //             }
    //           })
    //         )



    //         // for (const key in client?.filters) {
    //         //   if (Object.prototype.hasOwnProperty.call(client?.filters, key)) {
    //         //     if (key?.includes("locked")) {
    //         //       const element = client?.filters[key];
    //         //       console.log("element", element)


    //         //     }
    //         //     else {

    //         //       // const element = object[key];

    //         //       // setValue(key, element);
    //         //     }


    //         //   }
    //         // }
    //       }

    //     }
    //   }


    // }

    async function filterClientWork() {
      if (watch("account_id")) {
        console.log("first", watch("account_id"))
        let client = await fetchClient();
        if (client?.length > 0) {
          client = client[0]
          if (client?.filters) {

            setFields(
              fields => fields?.map(field => {
                if (!field) {
                  return { ...field, isLocked: false }
                }
                if (typeof (client?.filters[field.name]) == "number") {
                  const object = {
                    ...field,
                    isLocked: client?.filters?.[`${field.name}_locked`],
                  }
                  setValue(field.name, client?.filters?.[field.name])
                  return object

                } else {
                  return field
                }
              })
            )
          }
        }
      }
    }

    // if (watch("sub_account_id"))
    //   filterSubWork();

    // else 
    if (watch("account_id")) {
      filterClientWork();


    }



  }, [watch("account_id")])
  //#endregion


  //#region FORM SUBMITION
  const submitCallback = (status, message, data) => {
    if (status) {
      // toast.success(message, {
      //className:"successToast",
      //})
      resetAllFields()
      handleClose();
      Swal.fire({
        title: "Success!",
        text: message,
        icon: "success"
      }).then(() => {
        if (data.type === 'OPI On Demand') {
          navigate(`/appointments/view/${data?.id}`);
        } else {
          callback(data)
        }
      })
      dispatch(fetchAppointments());
    }
    else {
      console.log('onSubmit', error)
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const onSubmit = (data) => {
    dispatch(setError({}))
    const newData = { ...data };
    for (const key in newData) {
      if (Object.prototype.hasOwnProperty.call(newData, key)) {
        const element = newData[key];
        if (element == undefined) {
          delete newData[key];
        }
      }
    }
    if (item?.id) {
      dispatch(updateAppointment(newData, item?.id, submitCallback));
    } else
      dispatch(addAppointment(newData, submitCallback));
  }
  //#endregion


  //#region PREV NEXT HANDLERS
  const requiredFields = [
    "account_id",
    "date"
  ]


  // Next button handler
  const handleNext = () => {
    if (currentIndex < cards.length - 1) {
      // setCurrentIndex(currentIndex + 1);
      handleSubmit(
        (data) => {

          const clients = ConfirmData?.subClientId ? subClients : mainClients;
          if (currentIndex == 5 && clients?.length > 0) {
            if (!watch("estimated_duration")) {
              setErrors("estimated_duration", {
                type: "required",
                message: `Please enter a duration`
              })
              return
            }
          }
          console.log("currentIndex", currentIndex)
          if (currentIndex == 3 && watch("type") == "In Person") {
            if (!watch("facility_id") && !watch("address")) {
              setErrors("address", {
                type: "required",
                message: `Please enter a address`
              })
              return
            }
            else {
              setErrors("address", "")
            }
          }


          for (const key in data) {
            if (Object.prototype.hasOwnProperty.call(data, key)) {
              const element = data[key];
              if (cards[currentIndex]?.values?.includes(key)) {
                if (!element) {

                  setErrors(key, {
                    type: "required",
                    message: `This field is required`
                  })
                  return
                }
                else {
                  setErrors(key, null)
                }

              }

            }
          }
          setCurrentIndex(currentIndex + 1);

          // console.log("values]", data[cards[currentIndex].values])

          // if (!data[cards[currentIndex].values]) {
          //   setErrors("subclient_id", "Please select a client");
          //   return
          // }
          // else {
          //   setCurrentIndex(currentIndex + 1);
          // }

        },
        (error) => {
          console.log("Validation Errors:", error); // Error callback
        }
      )();
    }
  };

  // Previous button handler
  const handlePrev = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };
  //#endregion


  //#region  CARDS INITIALIZATION
  const cards = [
    {
      id: 1,
      content: "Select a Client",
      component: <AccountStep control={control} errors={errors} item={item} dispatch={dispatch} accounts={accounts} setConfirmData={setConfirmData}
        mainAccount={mainAccount} setMainAccount={setMainAccount}
        subClient={subClient} setSubclient={setSubclient}
        setAllSubAccounts={setAllSubAccounts}
        allSubAccounts={allSubAccounts}
        setValue={setValue}
      />,
      values: ["account_id"]
    },
    {
      id: 2,
      content: "Appointment Type",
      component: <TypeStep control={control} name="type" errors={errors} item={item} dispatch={dispatch} />
    },
    {
      id: 3,
      content: "Date & Time",
      component: <DateTimeStep control={control} watch={watch} errors={errors} item={item} dispatch={dispatch} />,
      values: ["date"]
    },
    {
      id: 4,
      content: "Language / Facility / Department",
      component: <LanguageStep control={control} watch={watch} errors={errors} item={item} dispatch={dispatch} setConfirmData={setConfirmData}
        clientData={ConfirmData}
        languageState={languageState} setLanguageState={setLanguageState}
        facilityState={facilityState} setFacilityState={setFacilityState}
        departmentState={departmentState} setDepartmentState={setDepartmentState}
      />
    },
    {
      id: 5,
      content: "Filters",
      component: <FilterStep control={control} watch={watch} errors={errors} item={item} dispatch={dispatch} setValue={setValue} fields={fields} setFields={setFields} />
    },
    {
      id: 6,
      content: "User Required Data",
      component: <UserDataStep control={control} errors={errors} setValue={setValue} item={item} dispatch={dispatch} />,
      values: ["requester_name", "requester_email", "caller_phone"]
    },

    {
      id: 7,
      content: "Required Data",
      component: <DynamicStep control={control} watch={watch} errors={errors} setValue={setValue} dynamicFields={dynamicFields} values={card5Values} setValues={setCard5Values} item={item} dispatch={dispatch} />
    },
    {
      id: 8,
      content: "Required Data",
      component: <GenderNoteStep control={control} errors={errors} setValue={setValue} item={item} dispatch={dispatch} />
    },
    {
      id: 9,
      content: "Confirm Data",
      component: <ConfirmDataStep control={control} handleSubmit={handleSubmit(onSubmit)} item={item} watch={watch} dispatch={dispatch} onClose={handleClose} ConfirmData={ConfirmData} />
    },
  ];
  //#endregion

  return (
    <div>
      <FormProvider
        {...method}
      >
        <form >

          {cards[currentIndex].component}

        </form>
      </FormProvider>
      <div className='row_shift Step_change'>
        {currentIndex > 0 && (
          <button type='button' onClick={handlePrev} className='main_button'>
            <img src="/images/arrow-right.png" alt />
          </button>
        )}

        {currentIndex < cards.length - 1 && (
          <button type='button' onClick={handleNext} className='main_button'>
            <img src="/images/arrow-left.png" alt="" style={{ filter: 'grayscale(1) brightness(5)' }} />
          </button>
        )}

        {currentIndex == cards.length - 1 &&
          <button type="button" className="main_button" onClick={resetAllFields}>

            {loader ?
              <>
                <Spinner size="sm">
                  Loading...
                </Spinner>

                <span>
                  {' '}Loading
                </span>
              </>
              :
              <span>
                {/* {item?.id ? "Update" : "Create"} */}
                Start Over
              </span>
            }
          </button>
        }
      </div>
    </div>
  )
}
//#endregion

//#region APPOINTMENT MAIN
const AddAppointment = ({ item, onClose, callback, show }) => {
  const closeModalRef = useRef();
  const [apptData, setApptData] = useState({})
  const [secondModal, setSecondModal] = useState(false);


  const handleCloseSecondModal = (data) => {
    setSecondModal(false);
  }

  const handleOpenSecondModal = (data) => {
    setApptData(data);
    setSecondModal(true);
  }


  return (
    <React.Fragment>
      <AfterAppointmentModal item={apptData} show={secondModal} handleClose={handleCloseSecondModal} />

      <BootstrapDialog

        fullWidth={true}
        maxWidth={"md"}
        onClose={(e, reason) => {
          if (reason != "backdropClick")
            onClose()
        }}
        aria-labelledby="customized-dialog-title"
        open={show}

        sx={{
          '& .MuiDialog-container': {
            alignItems: "center",
          },
          '& .MuiPaper-root': {
            overflowY: "visible",

          },
        }}
      >
        <div className="modal-content full_modal">
          <DialogTitle>
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Appointment</h5>
              <button onClick={onClose} type="button" className="btn-close" aria-label="Close"></button>
            </div>
          </DialogTitle>
          <div className="modal-body modal_form_body">
            <AddAppointmentForm item={item}
              handleClose={() => {
                onClose && onClose();
              }}
              callback={(data) => {
                callback();
                handleOpenSecondModal(data)
                onClose && onClose();
              }}
              show={show}
            />
          </div>
        </div>
      </BootstrapDialog>

      {/* <div className={`modal fade`} id="addAppointmentPopUp" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="addAppointmentPopUpLabel" aria-hidden="true" role="dialog">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content full_modal">
            <div className="modal-header header_modal align-items-center">
              <div></div>
              <h5 className="modal-title_u">{item?.id ? "Update" : "Add"} Appointment</h5>
             
            </div>
            <div className="modal-body modal_form_body">
              {
                <AddAppointmentForm item={item}
                  handleClose={() => {
                    closeModalRef.current.click();
                    onClose && onClose();
                  }}
                  callback={(data) => {
                    callback();

                    handleOpenSecondModal(data)
                    closeModalRef.current.click();
                    onClose && onClose();

                  }}
                  show={show}
                />}
            </div>
          </div>
        </div>
      </div> */}
    </React.Fragment>
  )
}
//#endregion

export default AddAppointment
